<template>
  <div class="affixStyle">
    <div :class="{'align-right': true, active: collapsed, 'is-hidden-menu': isHiddenMenu}">
      <slot class="close" name="button" />
    </div>
  </div>
</template>

<script>
// import { EventBus } from '@/utils/event-bus'
import { mapState, mapGetters } from 'vuex'

export default {
  name: 'FixBottom',
  data() {
    return {
      active: 0,
      // isCollapse: false,
    };
  },
  computed: {
    ...mapState('setting', ['collapsed']),
    ...mapGetters('iframe', ['isHiddenMenu']),
  }
  // created() {
  //   this.isCollapse = this.$store.state.setting?.collapsed || false
  //   EventBus.$on('onshrink', (collapse)=>{
  //     this.isCollapse = collapse
  //   })
  // },
  // beforeDestroy() {
  //   EventBus.$off('onshrink')
  // },
};
</script>

<style lang="less" scoped>
.affixStyle{
  position: fixed;
  // width: 100%;
  bottom: 0;
  left: 0px;
  right: 0;
  z-index: 100;
  transition: all 0.3s ease-in-out;
  // &.is-collapse {
  //   left: 64px;
  // }
}
.align-right {
  // text-align: right;
  height: 72px;
  background-color: #ffffff;
  // box-shadow: 0px -5px 5px -5px rgba(0, 0, 0, 0.2);
  // padding-top: 10px;
  box-sizing: border-box;
  padding-right: 30px;
  box-sizing: border-box;
  padding-left: 288px;
  display: flex;
  align-items: center;
  box-shadow: 4px 8px 10px 4px rgb(204 210 212);
  // .close {
  //   margin-right: 30px;
  // }
  &.active {
    padding-left: 96px;
  }
  &.is-hidden-menu {
    padding-left: 24px;
  }
}
</style>
